import { type ComponentProps, memo } from 'react';

export type AssetMobileVersionsContentProps = Pick<ComponentProps<'div'>, 'children'>;

export const AssetMobileVersionsContent = memo((props: AssetMobileVersionsContentProps) => {
  return <div className="flex size-full flex-col gap-5 bg-white p-5 dark:bg-black" {...props} />;
});

AssetMobileVersionsContent.displayName = 'AssetMobileVersionsContent';
